import Vue from 'vue'
import firebase from 'firebase'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Register from '@/components/auth/Register.vue'
import Signin from '@/components/auth/Signin.vue'
import Account from '../views/Account.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/signin',
    name: 'Signin',
    component: Signin
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record=> record.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) next('signin')
  else if (!requiresAuth && !currentUser) next()
  else next()
})

export default router
